const USER_UID = "XDhUOiM9g6Xz0cAg95wvIyHIOll1";
export default USER_UID;

export const makeAbsoluteUrl = (url) => {
    if (!url?.startsWith("http://") && !url?.startsWith("https://")) {
      return "http://" + url;
    }
    return url;
  };